import { signOut } from '@aws-amplify/auth';
import Cookies from 'js-cookie';

/**
 * Sign out and wipe app state, keeping the Cognito remembered-device keys
 * (and the remembered email) — clearing deviceKey would force MFA on every
 * future login even when the user asked to remember this device.
 */
export async function signOutUser(navigate) {
  try {
    Object.keys(Cookies.get()).forEach((cookieName) => {
      Cookies.remove(cookieName, { path: '/' });
      Cookies.remove(cookieName);
    });
    await signOut();
    const preserved = Object.entries(localStorage).filter(([key]) =>
      /\.(deviceKey|deviceGroupKey|randomPasswordKey)$/.test(key) ||
      key === 'rememberedEmail' ||
      key === 'mfaDeviceRememberedAt'
    );
    localStorage.clear();
    preserved.forEach(([key, value]) => localStorage.setItem(key, value));
    navigate('/login');
    window.location.reload();
  } catch (error) {
    console.error('Error signing out:', error);
  }
}

export default signOutUser;
